function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Banner } from "@neru/ui";
import * as ErrorMessages from "../../utils/errorMessageTransformer";
import * as Errors from "../../utils/errors";
export var ErrorBanner = function(param) {
    var tmp = param["data-testid"], dataTestId = tmp === void 0 ? "alert-banner" : tmp, error = param.error;
    if (!error) return null;
    var errorMessage;
    if (_instanceof(error, Errors.NeruError)) {
        errorMessage = ErrorMessages.getUserFriendlyMessage(error);
    } else if (typeof error === "string") {
        errorMessage = ErrorMessages.transformStringError(error);
    } else {
        errorMessage = "An unexpected error occurred";
    }
    return /*#__PURE__*/ _jsx(Banner, {
        connotation: "alert",
        "data-testid": dataTestId,
        message: errorMessage,
        open: true
    });
};

//# sourceMappingURL=ErrorBanner.js.map